
      if ('serviceWorker' in navigator) {
        if (import.meta.env.PROD) {
          window.addEventListener('load', () => navigator.serviceWorker.register('/sw.js'));
        } else {
          // dev: VitePWA가 sw.js를 안 만들어 SPA fallback(HTML)이 SW로 잡히는 걸 방지 +
          // 이전 prod/preview 세션에서 눌러앉은 묵은 SW가 흰 화면 일으키는 것 청소
          navigator.serviceWorker
            .getRegistrations()
            .then((rs) => rs.forEach((r) => r.unregister()));
        }
      }
    